// Replace these urls with your own deployment [don't give the last slash] trigger

module.exports = {
    API_URL: 'https://apiv2.musicder.workers.dev',
    TAGWRITER_URL: 'https://musicder.up.railway.app',
    CDN: 'https://cdn.musicder.workers.dev',
    BACKUP_CDN: 'https://backup.musicder.workers.dev'
}
